<div class="oe__panel-actions__container">
  <!-- SEPARATING APPARATUS -->
  <hr class="oe__panel-actions__hr" />

  <!-- LOADING (does not correspond to model state)-->
  <div
    *ngIf="_displayState === OENDisplayState.SHOW_LOADING || !data.dataLoadingComplete"
    fxLayout="row"
    fxLayoutAlign="center center"
    style="gap: var(--ds-cont-spacing-common-gap-xs)"
  >
    <span fxFlex class="oe__panel-actions__loading-label">Loading...</span>
  </div>

  <!-- ORDER ENTRY -->
  <div
    *ngIf="_displayState === OENDisplayState.SHOW_ORDER_ENTRY && data.dataLoadingComplete"
    fxLayout="row"
    fxLayoutAlign="space-between"
    style="gap: var(--ds-cont-spacing-common-gap-xs)"
  >
    <div
      fxLayout="row"
      fxLayoutAlign="space-between"
      style="gap: var(--ds-cont-spacing-common-gap-xs)"
    >
      <div fxLayout="row" style="gap: var(--ds-cont-spacing-common-gap-xs)">
        <button
          *ngIf="data.button_visibility.clear"
          pButton
          type="button"
          class="bfx-button-secondary-subtle"
          (click)="clear()"
          [label]="data.button_labels.clear | translate"
          [style.display]="data.button_visibility.clear ? 'block' : 'none'"
          [disabled]="data.lock_controls || data.button_locks.clear"
        ></button>
        <button
          *ngIf="data.button_visibility.modifyAbort"
          pButton
          type="button"
          class="bfx-button-secondary-bold"
          (click)="modifyAbort()"
          [label]="data.button_labels.abort | translate"
          [disabled]="data.lock_controls || data.button_locks.modifyAbort"
        ></button>
      </div>
      <button
        pButton
        type="button"
        class="bfx-button-secondary-bold"
        (click)="save()"
        [label]="data.button_labels.save | translate"
        [style.display]="data.button_visibility.save ? 'block' : 'none'"
        [disabled]="data.lock_controls || data.button_locks.save || !data.permissions.submit || data.saveDisabled"
      ></button>
    </div>
    <button
      pButton
      type="button"
      [ngClass]="{
        'bfx-button-primary': entryType == OENEntryType.GAMMA || data.submitClientIntent == null,
        'bfx-button-oe-buy': data.submitClientIntent === 0 && entryType != OENEntryType.GAMMA,
        'bfx-button-oe-sell': data.submitClientIntent === 1 && entryType != OENEntryType.GAMMA
      }"
      (click)="submit()"
      [label]="data.button_labels.submit | translate"
      [style.margin-left]="'auto'"
      [disabled]="data.lock_controls || data.button_locks.submit || !data.permissions.submit"
    ></button>
  </div>
  <!-- PROCESSING -->
  <div
    *ngIf="_displayState === OENDisplayState.SHOW_PROCESSING"
    fxLayout="row"
    fxLayoutAlign="space-between"
    style="gap: var(--ds-cont-spacing-common-gap-xs)"
  >
    <button
      pButton
      type="button"
      class="bfx-button-secondary-moderate"
      (click)="duplicate()"
      [label]="data.button_labels.duplicate | translate"
      [disabled]="data.lock_controls || data.button_locks.duplicate"
    ></button>
    <button
      pButton
      type="button"
      [ngClass]="{
        'bfx-button-primary': entryType == OENEntryType.GAMMA || data.submitClientIntent == null,
        'bfx-button-oe-buy': data.submitClientIntent === 0 && entryType != OENEntryType.GAMMA,
        'bfx-button-oe-sell': data.submitClientIntent === 1 && entryType != OENEntryType.GAMMA
      }"
      (click)="submit()"
      [label]="data.button_labels.submit | translate"
      [disabled]="data.lock_controls || data.button_locks.submit || !data.permissions.submit"
    ></button>
  </div>
  <!-- SUCCESS -->
  <div
    *ngIf="_displayState === OENDisplayState.SHOW_SUCCESS"
    fxLayout="row"
    fxLayoutAlign="space-between"
    style="gap: var(--ds-cont-spacing-common-gap-xs)"
    class="order-entry__state-success"
  >
    <div
      fxFlex="50%"
      fxLayout="row"
      fxLayoutAlign="start"
      style="gap: var(--ds-cont-spacing-common-gap-xs)"
    >
      <button
        pButton
        type="button"
        class="bfx-button-primary"
        (click)="newOrder()"
        [label]="data.button_labels.new | translate"
        [style.display]="data.button_visibility.new ? 'block' : 'none'"
        [style.margin-right]="data.button_visibility.close ? '5px' : '0px'"
        [disabled]="data.lock_controls || data.button_locks.new"
      ></button>
      <button
        pButton
        type="button"
        class="bfx-button-secondary-moderate"
        (click)="copy()"
        [label]="data.button_labels.copy | translate"
        [style.display]="data.button_visibility.copy ? 'block' : 'none'"
        [disabled]="data.lock_controls  || data.button_locks.copy"
      ></button>
      <button
        pButton
        type="button"
        class="bfx-button-secondary-moderate"
        (click)="duplicate()"
        [label]="data.button_labels.duplicate | translate"
        [style.display]="data.button_visibility.duplicate ? 'block' : 'none'"
        [disabled]="data.lock_controls || data.button_locks.duplicate"
      ></button>
    </div>
    <div
      fxFlex="50%"
      fxLayout="row"
      fxLayoutAlign="end"
      style="gap: var(--ds-cont-spacing-common-gap-xs)"
    >
      <button
        pButton
        type="button"
        class="bfx-button-secondary-bold"
        (click)="close()"
        [label]="data.button_labels.close | translate"
        [style.display]="data.button_visibility.close ? 'block' : 'none'"
        [disabled]="data.lock_controls || data.button_locks.close"
      ></button>
    </div>
  </div>

  <!-- MONITOR EXECUTION-->
  <div
    *ngIf="_displayState === OENDisplayState.SHOW_MONITOR_EXECUTION"
    fxLayout="row"
    fxLayoutAlign="space-between"
    style="gap: var(--ds-cont-spacing-common-gap-xs)"
    class="order-entry__state-success"
  >
    <button
      pButton
      type="button"
      class="bfx-button-secondary-moderate"
      (click)="duplicate()"
      [label]="data.button_labels.duplicate | translate"
      [style.display]="data.button_visibility.duplicate ? 'block' : 'none'"
      [disabled]="data.lock_controls  || data.button_locks.duplicate"
    ></button>
    <button
      pButton
      type="button"
      class="bfx-button-secondary-bold"
      (click)="close()"
      [label]="data.button_labels.close | translate"
      [style.display]="data.button_visibility.close ? 'block' : 'none'"
      [disabled]="data.lock_controls || data.button_locks.close"
    ></button>
  </div>

  <!-- REJECTED -->
  <div
    *ngIf="_displayState === OENDisplayState.SHOW_REJECTED"
    fxLayout="row"
    fxLayoutAlign="space-between"
    style="gap: var(--ds-cont-spacing-common-gap-xs)"
  >
    <div
      fxFlex="50%"
      fxLayout="row"
      fxLayoutAlign="start"
      style="gap: var(--ds-cont-spacing-common-gap-xs)"
    >
      <button
        pButton
        type="button"
        class="bfx-button-secondary-moderate"
        (click)="duplicate()"
        [label]="data.button_labels.duplicate | translate"
        [style.display]="data.button_visibility.duplicate ? 'block' : 'none'"
        [disabled]="data.lock_controls || data.button_locks.duplicate"
      ></button>
      <button
        pButton
        type="button"
        class="bfx-button-secondary-bold"
        (click)="abort()"
        [label]="data.button_labels.abort | translate"
        [style.display]="data.button_visibility.modAbort ? 'block' : 'none'"
        [disabled]="data.lock_controls || data.button_locks.modAbort"
      ></button>
    </div>
    <div
      fxFlex="50%"
      fxLayout="row"
      fxLayoutAlign="end"
      style="gap: var(--ds-cont-spacing-common-gap-xs)"
    >
      <button
        pButton
        type="button"
        class="bfx-button-secondary-bold"
        (click)="close()"
        [label]="data.button_labels.close | translate"
        [style.display]="data.button_visibility.close ? 'block' : 'none'"
        [disabled]="data.lock_controls || data.button_locks.close"
      ></button>
      <button
        pButton
        type="button"
        class="bfx-button-primary"
        (click)="edit()"
        [label]="data.button_labels.edit | translate"
        [style.display]="data.button_visibility.edit ? 'block' : 'none'"
        [disabled]="data.lock_controls || data.button_locks.edit"
      ></button>
    </div>
  </div>
  <!-- APPROVAL ALLOWED -->
  <div
    *ngIf="_displayState === OENDisplayState.SHOW_APPROVAL_ALLOWED"
    fxLayout="row"
    fxLayoutAlign="space-between"
    style="gap: var(--ds-cont-spacing-common-gap-xs)"
  >
    <div
      fxFlex="50%"
      fxLayout="row"
      fxLayoutAlign="start"
      style="gap: var(--ds-cont-spacing-common-gap-xs)"
    >
      <button
        pButton
        type="button"
        class="bfx-button-secondary-moderate"
        (click)="duplicate()"
        [label]="data.button_labels.duplicate | translate"
        [disabled]="data.lock_controls || data.button_locks.duplicate"
      ></button>
      <button
        pButton
        type="button"
        class="bfx-button-secondary-bold"
        (click)="abort()"
        [label]="data.button_labels.abort | translate"
        [disabled]="data.lock_controls || data.button_locks.diAbort"
      ></button>
    </div>
    <div
      fxFlex="50%"
      fxLayout="row"
      fxLayoutAlign="end"
      style="gap: var(--ds-cont-spacing-common-gap-xs)"
    >
      <button
        pButton
        type="button"
        class="bfx-button-negative"
        (click)="diReject()"
        [label]="data.button_labels.reject | translate"
        [disabled]="data.lock_controls || data.button_locks.diReject"
      ></button>
      <button
        pButton
        type="button"
        class="bfx-button-primary-bold"
        (click)="diApprove()"
        [label]="data.button_labels.approve | translate"
        [disabled]="data.lock_controls || data.button_locks.diApprove"
      ></button>
    </div>
  </div>
  <!-- APPROVAL INTERNAL -->
  <div
    *ngIf="_displayState === OENDisplayState.SHOW_APPROVAL_INTERNAL"
    fxLayout="row"
    fxLayoutAlign="space-between"
    style="gap: var(--ds-cont-spacing-common-gap-xs)"
  >
    <button
      pButton
      type="button"
      class="bfx-button-secondary-moderate"
      (click)="duplicate()"
      [label]="data.button_labels.duplicate | translate"
      [disabled]="data.lock_controls || data.button_locks.duplicate"
    ></button>
    <button
      pButton
      type="button"
      class="bfx-button-secondary-bold"
      (click)="abort()"
      [label]="data.button_labels.abort | translate"
      [disabled]="data.lock_controls || data.button_locks.diAbort"
    ></button>
  </div>
  <!-- APPROVAL EXTERNAL -->
  <div
    *ngIf="_displayState === OENDisplayState.SHOW_APPROVAL_EXTERNAL"
    fxLayout="row"
    fxLayoutAlign="space-between"
    style="gap: var(--ds-cont-spacing-common-gap-xs)"
  >
    <button
      pButton
      type="button"
      class="bfx-button-secondary-moderate"
      (click)="duplicate()"
      [label]="data.button_labels.duplicate | translate"
      [disabled]="data.lock_controls || data.button_locks.duplicate"
    ></button>
    <button
      pButton
      type="button"
      class="bfx-button-secondary-bold"
      (click)="abort()"
      [label]="data.button_labels.abort | translate"
      [disabled]="data.lock_controls || data.button_locks.diAbort"
    ></button>
  </div>
  <!-- SHOW_APPROVAL_EXTERNAL_MODIFY -->
  <div
    *ngIf="_displayState === OENDisplayState.SHOW_APPROVAL_EXTERNAL_MODIFY && data.dataLoadingComplete"
    fxLayout="row"
    fxLayoutAlign="space-between"
    style="gap: var(--ds-cont-spacing-common-gap-xs)"
  >
    <div
      fxFlex="50%"
      fxLayout="row"
      fxLayoutAlign="start"
      style="gap: var(--ds-cont-spacing-common-gap-xs)"
    >
      <button
        pButton
        type="button"
        class="bfx-button-secondary-moderate"
        (click)="duplicate()"
        [label]="data.button_labels.duplicate | translate"
        [disabled]="data.lock_controls || data.button_locks.duplicate"
      ></button>
      <!-- <button pButton type="button" fxFlex="100px" class="bfx-button-primary" (click)="abort()" [label]="data.button_labels.abort | translate" [disabled]="data.lock_controls || data.button_locks.modAbort"></button> -->
    </div>
    <div
      fxFlex="50%"
      fxLayout="row"
      fxLayoutAlign="end"
      style="gap: var(--ds-cont-spacing-common-gap-xs)"
    >
      <button
        pButton
        type="button"
        class="bfx-button-negative"
        (click)="modifyReject()"
        [label]="data.button_labels.force_reject | translate"
        [style.display]="data.button_visibility.modReject ? 'block' : 'none'"
        [disabled]="data.lock_controls || data.button_locks.modReject"
      ></button>
      <button
        pButton
        type="button"
        class="bfx-button-primary-bold"
        (click)="modifyAccept()"
        [label]="data.button_labels.force_accept | translate"
        [style.display]="data.button_visibility.modAccept ? 'block' : 'none'"
        [disabled]="data.lock_controls || data.button_locks.modAccept"
      ></button>
    </div>
  </div>
  <!-- SHOW_MODIFY_OUT_ACCEPTANCE -->
  <div
    *ngIf="_displayState === OENDisplayState.SHOW_MODIFY_OUT_ACCEPTANCE && data.dataLoadingComplete"
    fxLayout="row"
    fxLayoutAlign="space-between"
    style="gap: var(--ds-cont-spacing-common-gap-xs)"
  >
    <div
      fxFlex="50%"
      fxLayout="row"
      fxLayoutAlign="start"
      style="gap: var(--ds-cont-spacing-common-gap-xs)"
    >
      <button
        pButton
        type="button"
        class="bfx-button-secondary-moderate"
        (click)="duplicate()"
        [label]="data.button_labels.duplicate | translate"
        [disabled]="data.lock_controls || data.button_locks.duplicate"
      ></button>
      <button
        pButton
        type="button"
        class="bfx-button-secondary-bold"
        (click)="abort()"
        [label]="data.button_labels.abort | translate"
        [style.display]="data.button_visibility.modAbort ? 'block' : 'none'"
        [disabled]="data.lock_controls || data.button_locks.modAbort"
      ></button>
    </div>
    <div
      fxFlex="50%"
      fxLayout="row"
      fxLayoutAlign="end"
      style="gap: var(--ds-cont-spacing-common-gap-xs)"
    >
      <button
        pButton
        type="button"
        class="bfx-button-negative"
        (click)="modifyReject()"
        [label]="data.button_labels.reject | translate"
        [style.display]="data.button_visibility.modReject ? 'block' : 'none'"
        [disabled]="data.lock_controls || data.button_locks.modReject"
      ></button>
      <button
        pButton
        type="button"
        class="bfx-button-primary-bold"
        (click)="modifyAccept()"
        [label]="data.button_labels.accept | translate"
        [style.display]="data.button_visibility.modAccept ? 'block' : 'none'"
        [disabled]="data.lock_controls || data.button_locks.modAccept"
      ></button>
    </div>
  </div>
  <!-- ACCEPTANCE ALLOWED -->
  <div
    *ngIf="_displayState === OENDisplayState.SHOW_ACCEPTANCE_ALLOWED"
    fxLayout="row"
    fxLayoutAlign="space-between"
    style="gap: var(--ds-cont-spacing-common-gap-xs)"
  >
    <div
      fxFlex="50%"
      fxLayout="row"
      fxLayoutAlign="start"
      style="gap: var(--ds-cont-spacing-common-gap-xs)"
    >
      <button
        pButton
        type="button"
        class="bfx-button-secondary-moderate"
        (click)="duplicate()"
        [label]="data.button_labels.duplicate | translate"
        [disabled]="data.lock_controls || data.button_locks.duplicate"
      ></button>
      <button
        pButton
        type="button"
        class="bfx-button-secondary-bold"
        (click)="abort()"
        [label]="data.button_labels.abort | translate"
        [style.display]="data.button_visibility.trAbort ? 'block' : 'none'"
        [disabled]="data.lock_controls || data.button_locks.trAbort"
      ></button>
    </div>
    <div
      fxFlex="50%"
      fxLayout="row"
      fxLayoutAlign="end"
      style="gap: var(--ds-cont-spacing-common-gap-xs)"
    >
      <button
        pButton
        type="button"
        class="bfx-button-negative"
        (click)="trReject()"
        [label]="data.button_labels.reject | translate"
        [style.display]="data.button_visibility.trReject ? 'block' : 'none'"
        [disabled]="data.lock_controls || data.button_locks.trReject"
      ></button>
      <button
        pButton
        type="button"
        class="bfx-button-primary-bold"
        (click)="trAccept()"
        [label]="data.button_labels.accept | translate"
        [style.display]="data.button_visibility.trAccept ? 'block' : 'none'"
        [disabled]="data.lock_controls || data.button_locks.trAccept"
      ></button>
    </div>
  </div>
  <!-- ACCEPTANCE CALL -->
  <div *ngIf="_displayState === OENDisplayState.SHOW_ACCEPTANCE_CALL" style="margin-bottom: 10px">
    <div fxFlex="100%" fxLayout="row" fxLayoutAlign="space-between" style="gap: 2px">
      <button
        pButton
        type="button"
        class="bfx-button-secondary-moderate"
        (click)="duplicate()"
        [label]="data.button_labels.duplicate | translate"
        [disabled]="data.lock_controls || data.button_locks.duplicate"
      ></button>
      <button
        pButton
        type="button"
        class="bfx-button-secondary-bold"
        (click)="abort()"
        [label]="data.button_labels.abort | translate"
        [style.display]="data.button_visibility.trAbort ? 'block' : 'none'"
        [disabled]="data.lock_controls || data.button_locks.trAbort"
      ></button>
      <div fxFlex="100%"></div>
      <button
        pButton
        type="button"
        class="bfx-button-negative"
        (click)="trReject()"
        [label]="data.button_labels.reject | translate"
        [style.display]="data.button_visibility.trReject ? 'block' : 'none'"
        [disabled]="data.lock_controls || data.button_locks.trReject"
      ></button>
      <button
        pButton
        type="button"
        class="bfx-button-primary-bold"
        (click)="trAcceptTop()"
        [label]="data.button_labels.accept_top | translate"
        [style.display]="data.button_visibility.trAccept ? 'block' : 'none'"
        [disabled]="data.lock_controls || data.button_locks.trAccept"
      ></button>
      <button
        pButton
        type="button"
        class="bfx-button-primary-bold"
        (click)="trAcceptDown()"
        [label]="data.button_labels.accept_down | translate"
        [style.display]="data.button_visibility.trAccept ? 'block' : 'none'"
        [disabled]="data.lock_controls || data.button_locks.trAccept"
      ></button>
    </div>
  </div>
  <!-- ACCEPTANCE EXTERNAL  -->
  <div
    *ngIf="_displayState === OENDisplayState.SHOW_ACCEPTANCE_EXTERNAL"
    fxLayout="row"
    fxLayoutAlign="space-between"
    style="gap: var(--ds-cont-spacing-common-gap-xs)"
  >
    <div
      fxFlex="50%"
      fxLayout="row"
      fxLayoutAlign="start"
      style="gap: var(--ds-cont-spacing-common-gap-xs)"
    >
      <button
        pButton
        type="button"
        class="bfx-button-secondary-moderate"
        (click)="duplicate()"
        [label]="data.button_labels.duplicate | translate"
        [disabled]="data.lock_controls || data.button_locks.duplicate"
      ></button>
    </div>
    <div
      fxFlex="50%"
      fxLayout="row"
      fxLayoutAlign="end"
      style="gap: var(--ds-cont-spacing-common-gap-xs)"
    >
      <button
        pButton
        type="button"
        class="bfx-button-negative"
        (click)="trReject()"
        [label]="data.button_labels.force_reject | translate"
        [style.display]="data.button_visibility.trReject ? 'block' : 'none'"
        [disabled]="data.lock_controls || data.button_locks.trReject"
      ></button>
      <button
        pButton
        type="button"
        class="bfx-button-primary-bold"
        (click)="trAccept()"
        [label]="data.button_labels.force_accept | translate"
        [style.display]="data.button_visibility.trAccept ? 'block' : 'none'"
        [disabled]="data.lock_controls || data.button_locks.trAccept"
      ></button>
    </div>
  </div>
  <!-- SHOW_ABORT -->
  <!-- SHOW_ABORT is intentionally Skipped -->
  <!-- TOLERANCES -->
  <div
    *ngIf="_displayState === OENDisplayState.SHOW_TOLERANCE"
    fxLayout="row"
    fxLayoutAlign="space-between"
    style="gap: var(--ds-cont-spacing-common-gap-xs)"
  >
    <button
      pButton
      type="button"
      class="bfx-button-secondary-bold"
      (click)="toleranceEdit()"
      [label]="data.button_labels.edit | translate"
      [disabled]="data.lock_controls || data.button_locks.edit"
    ></button>
    <button
      pButton
      type="button"
      class="bfx-button-primary-bold"
      (click)="toleranceAccept()"
      [label]="data.button_labels.accept | translate"
      [disabled]="data.lock_controls || data.button_locks.toleranceAccept"
    ></button>
  </div>
  <div
    *ngIf="_displayState === OENDisplayState.SHOW_NEGATIVE_MARKUP_WARN"
    fxLayout="row"
    fxLayoutAlign="space-between"
    style="gap: var(--ds-cont-spacing-common-gap-xs)"
  >
    <button
      pButton
      type="button"
      class="bfx-button-secondary-bold"
      (click)="negativeMarkupEdit()"
      [label]="data.button_labels.edit | translate"
      [disabled]="data.lock_controls || data.button_locks.edit"
    ></button>
    <button
      pButton
      type="button"
      class="bfx-button-primary-bold"
      (click)="negativeMarkupAccept()"
      [label]="data.button_labels.accept | translate"
      [disabled]="data.lock_controls || data.button_locks.negativeMarkup"
    ></button>
  </div>

  <!-- Show BM Zero Amount Warning -->
  <div
    *ngIf="_displayState === OENDisplayState.SHOW_BM_ZERO_AMOUNT_WARN"
    fxLayout="row"
    fxLayoutAlign="space-between"
    style="gap: var(--ds-cont-spacing-common-gap-xs)"
  >
    <button
      pButton
      type="button"
      class="bfx-button-secondary-bold"
      (click)="bmZeroAmountEdit()"
      [label]="data.button_labels.edit | translate"
      [disabled]="data.lock_controls || data.button_locks.edit"
    ></button>
    <button
      pButton
      type="button"
      class="bfx-button-primary-bold"
      (click)="bmZeroAmountAccept()"
      [label]="data.button_labels.accept | translate"
      [disabled]="data.lock_controls || data.button_locks.accept"
    ></button>
  </div>

  <!-- UNLOCKED -->
  <div
    *ngIf="_displayState === OENDisplayState.SHOW_UNLOCKED"
    fxLayout="row"
    fxLayoutAlign="space-between"
    style="gap: var(--ds-cont-spacing-common-gap-xs)"
  >
    <div
      fxFlex="50%"
      fxLayout="row"
      fxLayoutAlign="start"
      style="gap: var(--ds-cont-spacing-common-gap-xs)"
    >
      <button
        pButton
        type="button"
        class="bfx-button-secondary-moderate"
        (click)="duplicate()"
        [label]="data.button_labels.duplicate | translate"
        [style.display]="data.button_visibility.duplicate ? 'block' : 'none'"
        [disabled]="data.lock_controls || data.button_locks.duplicate"
      ></button>
    </div>
    <div
      fxFlex="50%"
      fxLayout="row"
      fxLayoutAlign="end"
      style="gap: var(--ds-cont-spacing-common-gap-xs)"
    >
      <button
        pButton
        type="button"
        class="bfx-button-secondary-bold"
        (click)="close()"
        [label]="data.button_labels.close | translate"
        [style.margin-right]="data.button_visibility.edit ? '5px' : '0px'"
        [disabled]="data.lock_controls || data.button_locks.close"
      ></button>
      <button
        pButton
        type="button"
        class="bfx-button-primary"
        (click)="edit()"
        [label]="data.button_labels.edit | translate"
        [style.display]="data.button_visibility.edit ? 'block' : 'none'"
        [disabled]="data.lock_controls || data.button_locks.edit"
      ></button>
    </div>
  </div>
  <!-- AMEND MARKUP -->
  <div
    *ngIf="_displayState === OENDisplayState.SHOW_AMEND_MARKUP && data.dataLoadingComplete"
    fxLayout="row"
    fxLayoutAlign="space-between"
    style="gap: var(--ds-cont-spacing-common-gap-xs)"
  >
    <div
      fxFlex="50%"
      fxLayout="row"
      fxLayoutAlign="start"
      style="gap: var(--ds-cont-spacing-common-gap-xs)"
    >
      <button
        pButton
        type="button"
        class="bfx-button-primary"
        (click)="amCancel()"
        [label]="data.button_labels.cancel | translate"
        [disabled]="data.lock_controls || data.button_locks.amCancel"
      ></button>
    </div>
    <div
      fxFlex="50%"
      fxLayout="row"
      fxLayoutAlign="end"
      style="gap: var(--ds-cont-spacing-common-gap-xs)"
    >
      <button
        pButton
        type="button"
        class="bfx-button-negative"
        (click)="amReject()"
        [label]="data.button_labels.reject | translate"
        [disabled]="data.lock_controls || data.button_locks.amReject"
      ></button>
      <button
        pButton
        type="button"
        class="bfx-button-primary-bold"
        (click)="amApprove()"
        [label]="data.button_labels.approve | translate"
        [disabled]="data.lock_controls || data.button_locks.amApprove"
      ></button>
    </div>
  </div>
  <!-- EXPIRY PENDING -->
  <div
    *ngIf="_displayState === OENDisplayState.SHOW_EXPIRY_PENDING"
    fxLayout="row"
    fxLayoutAlign="space-between"
    style="gap: var(--ds-cont-spacing-common-gap-xs)"
    class="order-entry__state-success"
  >
    <div
      fxFlex="50%"
      fxLayout="row"
      fxLayoutAlign="start"
      style="gap: var(--ds-cont-spacing-common-gap-xs)"
    >
      <button
        pButton
        type="button"
        class="bfx-button-secondary-moderate"
        (click)="copy()"
        [label]="data.button_labels.copy | translate"
        [disabled]="data.lock_controls || data.button_locks.copy"
      ></button>
    </div>
    <div
      fxFlex="50%"
      fxLayout="row"
      fxLayoutAlign="end"
      style="gap: var(--ds-cont-spacing-common-gap-xs)"
    >
      <button
        pButton
        type="button"
        class="bfx-button-primary"
        (click)="newOrder()"
        [label]="data.button_labels.new | translate"
        [style.display]="data.button_visibility.new ? 'block' : 'none'"
        [disabled]="data.lock_controls || data.button_locks.new"
      ></button>
      <button
        pButton
        type="button"
        class="bfx-button-secondary-bold"
        (click)="close()"
        [label]="data.button_labels.close | translate"
        [style.display]="data.button_visibility.close ? 'block' : 'none'"
        [disabled]="data.lock_controls || data.button_locks.close"
      ></button>
    </div>
  </div>

  <!-- NOT_VISIBLE -->
  <div
    *ngIf="_displayState === OENDisplayState.SHOW_LOST_HIDDEN"
    fxLayout="row"
    fxLayoutAlign="space-between"
    style="gap: var(--ds-cont-spacing-common-gap-xs)"
  >
    <div
      fxFlex="1 1"
      fxLayout="row"
      fxLayoutAlign="end"
      style="gap: var(--ds-cont-spacing-common-gap-xs)"
    >
      <button
        pButton
        type="button"
        class="bfx-button-secondary-bold"
        (click)="close()"
        [label]="data.button_labels.close | translate"
        [style.margin-right]="data.button_visibility.edit ? '5px' : '0px'"
        [disabled]="data.lock_controls || data.button_locks.close"
      ></button>
    </div>
  </div>
</div>
